<template>
  <ons-page id="host"
    v-bind:class="{ 'page__content-ph-animate': initLoading }"
  >
    <app-bar :title="(host && host.user && host.user.name) || title" :enable-home="true" :enable-ticker="true" />
    <v-ons-progress-bar indeterminate class="app-bar-progress" v-show="loading"></v-ons-progress-bar>
    <div class="channel-header ">
      <section>
        <div class="avatar-line justify-row container">
          <div class="avatar avatar-host">
            <div class="avatar-border"></div>
            <img class="round-max" :src="constants.phImg70x70" v-if="initLoading || !host || !host.user">
            <img-with-placeholder class="round-max" :src="constants.phImg70x70" :data-src="sizeImg(host.user.avatar.base_url, 70, 70)" :alt="host.user.avatar.alt_text" v-else />
          </div>
          <div class="main-item">
            <h2 class="name ph-text" v-if="initLoading">■■■■■■■ ■■■■■■■</h2>
            <h2 class="name" v-else-if="host && host.user">{{ host && host.user && host.user.name }}</h2>
            <h2 class="name ph-text" v-else-if="isOffline">■■■■■■■ ■■■■■■■</h2>
            <div class="tools">
              <ons-button class="donate js-donate btn-outline" modifier="small"
                v-if="false"
                @click="openDonateActionSheet()"
              >
                <span class="icon-sm">
                  <icon-donate />
                </span>
                <span class="txt">
                Donate
                </span>
              </ons-button>
              <ons-button class="follow js-button-toggle btn-outline" modifier="small"
                v-bind:class="{ switched: host && host.is_following, 'ph-icon': initLoading }"
                :disabled="initLoading || followLoading"
                @click="toggleFollow()"
              >
                <span class="icon-sm">
                  <icon-follow />
                </span>
                <span class="ph-text" v-if="initLoading">■■■■■■■■■■</span>
                <span class="txt" v-else>{{ (host && host.is_following) ? $t("host.unfollow") : $t("host.follow") }}</span>
              </ons-button>
            </div>
          </div>
        </div>
        <div class="container">
          <p class="p ph-text" v-if="initLoading">■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■</p>
          <p class="p" v-else-if="host">{{ host.description }}</p>
          <p class="p" v-if="isOffline">{{ $t("host.offline") }}</p>
        </div>
      </section>
    </div>
    <div class="tabs tabbar tabbar--top" data-control="#tabs-content-host">
      <label class="tabbar__item" data-index="1">
      <input type="radio" name="tab-host" checked="checked" @click="setTabIndex(0)">
      <button class="tabbar__button"
        v-bind:class="{ 'ph-btn': initLoading }"
      >
        {{ $t("host.nav.channels") }}
      </button>
      </label>
      <label class="tabbar__item" data-index="2">
      <input type="radio" name="tab-host" @click="setTabIndex(1)">
      <button class="tabbar__button">
        {{ $t("host.nav.episodes") }}
      </button>
      </label>
    </div>
    <div class="tabs-content" id="tabs-content-host">
      <div v-show="tabIndex === 0">
        <div class="pd-bottom container">
          <channel-list-detailed :channels="host && host.channels" :on-toggle-subscribe-start="onToggleSubscribeStart" :on-toggle-subscribe-error="onToggleSubscribeError" :on-toggle-subscribe-end="onToggleSubscribeEnd" :loading="initLoading" :loading-item-count="5" />
        </div>
        <div class="center-align" v-if="!initLoading && !isOffline">
          <p>
            <v-ons-button class="btn-outline" modifier="long"
              v-show="host && !host._channelsEnded"
              :disabled="loading"
              @click="loadMoreChannels()"
            >{{ $t("ui.load_more") }}</v-ons-button>
          </p>
          <p v-show="host && host._channelsEnded">{{ $t("ui.no_more") }}</p>
        </div>
      </div>
      <div v-show="tabIndex === 1">
        <div class="pd-bottom container">
          <episode-list-detailed :episodes="host && host.episodes" />
        </div>
        <div class="center-align" v-if="!initLoading && !isOffline">
          <p>
            <v-ons-button class="btn-outline" modifier="long"
              v-show="host && !host._episodesEnded"
              :disabled="loading"
              @click="loadMoreEpisodes()"
            >{{ $t("ui.load_more") }}</v-ons-button>
          </p>
          <p v-show="host && host._episodesEnded">{{ $t("ui.no_more") }}</p>
        </div>
      </div>
    </div>
    <v-ons-toast :visible="shouldShowGoOnlineToast" animation="ascend">
      {{ $t("messages.go_online_for_details") }}
      <button @click="goOnline">{{ $t("ui.go_online") }}</button>
    </v-ons-toast>
    <float-player class="player-iphonex-apply-bottom-notch" />
  </ons-page>
</template>

<script>
import AppBar from '@/components/AppBar.vue';
import ChannelListDetailed from '@/components/ChannelListDetailed.vue';
import EpisodeListDetailed from '@/components/EpisodeListDetailed.vue';
import FloatPlayer from '@/components/FloatPlayer.vue';
import Host from '@/models/Host';
import TabHelper from '@/mixins/TabHelper';
import WatchUserChangeHelper from '@/mixins/WatchUserChangeHelper';

export default {
  name: 'host',
  props: ['id', 'title'],
  components: {
    'app-bar': AppBar,
    'channel-list-detailed': ChannelListDetailed,
    'episode-list-detailed': EpisodeListDetailed,
    'float-player': FloatPlayer,
  },
  mixins: [TabHelper, WatchUserChangeHelper],

  data() {
    return {
      initLoading: true,
      loading: true,
      followLoading: false,
    };
  },

  computed: {
    host() {
      return Host.query().whereId(this.id).with('user').with('channels.episodes').with('episodes.channel').first();
    },
  },

  methods: {
    onToggleSubscribeStart() {
      this.loading = true;
    },
    onToggleSubscribeError(error) {
      console.log(error);
      this.showSomethingWrongToast();
    },
    onToggleSubscribeEnd() {
      this.loading = false;
    },
    toggleFollow() {
      if (!this.checkAndShowRequireLoginToast()) { return; }
      if (this.showGoOnlineToast(this.$t("messages.go_online_to_follow"))) { return; }
      let that = this;
      this.loading = true;
      this.followLoading = true;
      this.host.toggleFollow(this.currentUser.id)
        .catch(function (error) {
          console.log(error);
          that.showSomethingWrongToast();
        }).finally(() => {
          this.loading = false;
          this.followLoading = false;
        });
    },
    loadMoreChannels() {
      let that = this;
      this.loading = true;
      this.host.fetchMoreChannels()
        .catch(function (error) {
          console.log(error);
          that.showSomethingWrongToast();
        }).finally(() => {
          this.loading = false;
        });
    },
    loadMoreEpisodes() {
      let that = this;
      this.loading = true;
      this.host.fetchMoreEpisodes()
        .catch(function (error) {
          console.log(error);
          that.showSomethingWrongToast();
        }).finally(() => {
          this.loading = false;
        });
    },
    onUserChanged() {
      let that = this;
      this.loading = true;
      Host.fetchById(this.id)
        .catch(function (error) {
          console.log(error);
          if (that.isOffline) { return; }
          that.showSomethingWrongToast();
        }).finally(() => {
          this.loading = false;
        });
    },
  },

  created() {
    let that = this;
    this.initLoading = true;
    this.loading = true;
    Host.fetchById(this.id)
      .catch(function (error) {
        if (error.response && error.response.status === 401) {
          that.navigatorResetLogin(that.$t("messages.login_required"));
        } else {
          console.log(error);
          if (that.isOffline) { return; }
          that.showSomethingWrongToast();
        }
      }).finally(() => {
        this.initLoading = false;
        this.loading = false;
      });
  },
};
</script>
